import LangService from "@/services/LangService";
import UserService from "@/services/UserService";

let getCaptions = function(store) {
  return LangService.getCaptions().then(response => {
    store.dispatch("setCaptions", response.data.payload);
    localStorage.setItem("token", response.headers.my_token);
    return;
  });
};

let init = function(store) {
  let token = localStorage.getItem("token");
  if (token) {
    return UserService.userInfo()
      .then(response => {
        let userData = response.data.payload;
        store.dispatch("setUser", userData);

        if (userData.language == 1) {
          localStorage.setItem("language", "lang-mon");
        } else {
          localStorage.setItem("language", "lang-eng");
        }

        return getCaptions(store);
      })
      .catch(() => {
        return getCaptions(store);
      });
  } else {
    return getCaptions(store);
  }
};

export default init;
